import { useQuery } from '@tanstack/react-query';

import { api } from './lib/api';
import { useStore } from './lib/store';
import type { MeResponse } from './lib/types';
import { AdminTab } from './tabs/AdminTab';
import { ClosedScreen } from './components/ClosedScreen';
import { Toast } from './components/Toast';

export function App(): JSX.Element {
  const tab = useStore((s) => s.tab);
  const setTab = useStore((s) => s.setTab);
  const me = useQuery<MeResponse>({
    queryKey: ['me'],
    queryFn: () => api<MeResponse>('/v1/me'),
  });

  if (tab === 'admin' && me.data?.isAdmin) {
    return (
      <div className="flex h-screen flex-col bg-bg text-text">
        <header className="flex items-center justify-between border-b border-white/5 bg-bg-elev px-4 py-3">
          <span className="font-display text-sm">Админка</span>
          <button onClick={() => setTab('closed')} className="text-sm text-text-dim">
            ✕ Закрыть
          </button>
        </header>
        <main className="min-h-0 flex-1">
          <div className="mx-auto h-full w-full lg:max-w-3xl">
            <AdminTab />
          </div>
        </main>
        <Toast />
      </div>
    );
  }

  return (
    <>
      <ClosedScreen isAdmin={!!me.data?.isAdmin} />
      <Toast />
    </>
  );
}
